const nationality =
{
    title         : 'Nationalité',
    empty         : '-----'
};

export default nationality ;